import { useEffect, useState, type ReactNode } from 'react';

interface ClientOnlyProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function ClientOnly({ children, fallback = null }: ClientOnlyProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!mounted) return <>{fallback}</>;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
